export default __webpack_public_path__ + "static/media/Thief's Jerkin of the Hidden Palace.d0524d88.jpg";